// removed by extract-text-webpack-plugin
module.exports = {"a-link":"_10kee0Qhp4rvt9Qlbu7OM8","a-link--navigation":"dJu0T462VemlPS3Ad9AxY"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/ExternalLink/style.scss
// module id = 880
// module chunks = 0